import styled from "styled-components";
import { keyframes, css } from "styled-components";

let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

const showInfo = keyframes`
  0% {
    transform: translateX(5%);
  }
  80% {
    transform: translateX(95%);
  }
  100% {
    transform: translateX(100%);
    box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  }
`;

const hideInfo = keyframes`
  0% {
    transform: translateX(95%);
  }
  80% {
    transform: translateX(5%);
  }
  100% {
    transform: translateX(0%);
  }
`;

const showInfoMobile = keyframes`
  0% {
    transform: translate(100%, 40px);
    opacity: 0;
  }
  80% {
    transform: translate(100%, 45px);
    opacity: 0.85;
  }
  100% {
    transform: translate(100%, 56px);
    opacity: 1;
  }
`;

const hideInfoMobile = keyframes`
  0% {
    transform: translate(100%, 56px);
    opacity: 1;
  }
  80% {
    transform: translate(100%, 45px);
    opacity: 0.85;
  }
  100% {
    transform: translate(100%, 0px);
    opacity: 0;
    visibility:hidden;
  }
`;

export const Info = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(100%);
  background-color: rgba(0, 103, 120, 0.9);
  color: white;
  width: ${isSafari ? "292px" : "341px"};
  height: 100%;
  padding: 16px 37px 17px 31px;
  color: white;
  font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 2;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  animation-direction:reverse;
  ${({ show }) => show ? css`animation: ${showInfo} 0.5s linear forwards` : css`animation: ${hideInfo} ${isSafari ? "1ms" : "0ms"} linear forwards`};
  ${({ activateReverseAnimation, show }) => activateReverseAnimation ? (!show && isIE ? "animation-duration: 0.5ms" : "animation-duration: 0.5s") : ''}
`;

export const Info1 = styled(Info)`
@media only screen and(max-width: 320px) {
  padding: 16px 20px;
  right: 60px;
  top: -99px;
  width: 280px;
  z-index: 4;
  transform: translate(100%, 0%);
  animation: ${showInfoMobile} ${isSafari ? "1ms" : "0ms"} linear forwards;
}
@media only screen and(min-width: 321px) and(max-width: 375px) {
  z-index: 5;
  padding: 16px 20px;
  right: 66px;
  top: -99px;
  width: 335px;
  transform: translate(100%, 0%);
  animation: ${showInfoMobile} ${isSafari ? "1ms" : "0ms"} linear forwards;
}
@media only screen and(min-width: 376px) and(max-width: 425px) {
  z-index: 5;
  top: -99px;
  right: 66px;
  width: 385px;
  padding: 16px 20px;
  transform: translate(100%, 0%);
  animation: ${showInfoMobile} ${isSafari ? "1ms" : "0ms"} linear forwards;
}
@media only screen and(min-width: 426px) and(max-width: 768px) {
  z-index: 5;
  top: -108px;
  right: 272px;
  width: 719px;
  padding: 16px 20px;
  transform: translate(100%, 0%);
  animation: ${showInfoMobile} ${isSafari ? "1ms" : "0ms"} linear forwards;
}
`;

export const Mask = styled.div`
  position:absolute;
  z-index:5;
  width:100%;
  height:100%;
  transform:translateX(-100%);
  background:#fff;
`;

export const Info2 = styled(Info)`
  z-index: 4;
  display: ${props => props.flowName === "MAC" ? 'flex' : 'inline-block'};
  padding-right: 90px;
  @media only screen and (max-width: 991.92px) {
    padding: 30px 20px;
    padding-right:6rem;
    left: -100%;
    top: '0px';
    width: 100%;
    display:inline-block;
    transform: translate(100%, 0%);
    ${({ show }) => show ? css`animation: ${showInfoMobile} 0.5s linear forwards` : css`animation: ${hideInfoMobile} ${isSafari ? "1ms" : "0ms"} linear forwards`};
    ${({ activateReverseAnimation, show }) => activateReverseAnimation ? (!show && isIE ? "animation-duration: 0.5ms" : "animation-duration: 0.5s") : ''}
    height:auto;
  }
`;

export const Triangle = styled.div`
  position: absolute;
  top: 50%;
  left: -2px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 11px solid white;
  border-bottom: 8px solid transparent;
  transform: translateY(-50%);
  @media only screen and(min-width: 320px) and(max-width: 991.92px) {
    top: -3px;
    left: ${props => (props.left ? props.left : "unset")};
    border-top: 6px solid transparent;
    border-left: 8px solid white;
    border-bottom: 6px solid transparent;
    transform: rotate(90deg);
  }
`;

export const InfoView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
    & > a {
      position: absolute;
      margin: auto; 
      top: 0rem; 
      bottom: 0; 
      right: 1rem;
      @media only screen and (max-width: 991.92px) {
        bottom: 18px;
        top: initial;
      }
    }
    & > div {
      max-width: 100%;
      overflow: hidden;
    }
    & > div > div {
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis
    }
`;

export const CloseTag = styled.div`
  position: absolute;
  right: 16px;
  top: 4px;
  font-size: 22px;
  @media only screen and (min-width: 1025px) {
    display: none;
  }
`;

export const MobileHoverHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
`;
